// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"28":"BadMetronome","442":"MafsTwo","594":"about","647":"DyeLif","790":"TriangleModel","872":"MafsOne"}[chunkId] || chunkId) + "." + {"28":"e48669d5","316":"2ff7e377","442":"44c532b2","594":"51edf863","647":"57298d40","790":"45613b9f","815":"eb701948","872":"2ff7e377"}[chunkId] + ".css";
};